import isMobile from 'ismobilejs';

const { navigator } = window;

export default () => isMobile(navigator);
